import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { memo, useContext, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HelpButton, HelpPopup } from '@bingads-webui-react/help-popup';
import { InstrumentationContext } from '@bingads-webui-campaign-react/mca-instrumentation';
import { getInlineHelpButtonStyles } from '@bingads-webui-campaign-react/common-styles';

export const InlineHelpUnstyled = memo((props) => {
  const {
    classes,
    topic,
    withoutSpace,
    button, // setting this to true is highly encouraged due to accessibility reasons
    ariaLabel,
  } = props;

  const i18n = useContext(I18nContext);
  const [instrumentationService] = useContext(InstrumentationContext);

  const instrumentationActivity = useMemo(() => {
    if (instrumentationService) {
      const { instrumentation } = instrumentationService;
      const inlineHelpScenario = instrumentation.inlineHelp.create();
      return inlineHelpScenario.inlineHelp.create();
    }

    return { trace: _.noop };
  }, [instrumentationService]);

  const handleClick = useCallback(() => {
    instrumentationActivity.trace(`Help popup clicked on topic: ${topic}`);
  }, [instrumentationActivity, topic]);

  const Help = button ? HelpButton : HelpPopup;

  return (
    <span
      className={classNames('mca-inline-help', {
        [classes.inlineHelp]: true,
        [classes.withSpace]: !withoutSpace,
      })}
      role="presentation"
      onClick={handleClick}
    >
      <Help
        aria-label={ariaLabel || i18n.getString(_TL_('Learn more'))}
        topic={topic}
      />
    </span>
  );
});

InlineHelpUnstyled.propTypes = {
  topic: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    inlineHelp: PropTypes.string,
  }).isRequired,
  withoutSpace: PropTypes.bool,
  button: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

InlineHelpUnstyled.defaultProps = {
  withoutSpace: false,
  button: false,
  ariaLabel: null,
};

export const getHelpButtonStyles = getInlineHelpButtonStyles;

export const InlineHelp = withDefaultStyles(
  InlineHelpUnstyled,
  (components, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
    inlineHelp: {
      display: 'inline',
      fontSize: '15px !important',
      fontWeight: 'normal',
      ...getHelpButtonStyles({ palette, iconFontFamily }),
    },
    withSpace: {
      marginLeft: 3,
    },
  })
);

